import React from 'react'
import why_1 from '../../../assets/images/why-choose/why-choose-two-1.png'

const WhyChouse = () => {
    return (
        <>
            <div className="why-choose-section-two">
                <div className="container">
                    <div className="why-choose-image-two">
                        <img
                            src={why_1}
                            alt="why-choose"
                            className="animate zoomIn wow"
                            data-wow-duration="2500ms"
                        />
                    </div>
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="heading-box light text-center">
                                <span
                                    className="sub-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Why Choos Us
                                </span>
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Achieving Growth Through Collaboration
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-lg-4">
                            <div className="why-choose-left-two">
                                <div
                                    className="why-choose-box-two animate fadeInLeft wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <div className="why-choose-icon-two">
                                        <svg
                                            width={53}
                                            height={49}
                                            viewBox="0 0 53 49"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3.125 9.5H49.875C51.0486 9.5 52 10.4514 52 11.625V45.625C52 46.7986 51.0486 47.75 49.875 47.75H3.125C1.95139 47.75 1 46.7986 1 45.625V11.625C1 10.4514 1.95139 9.5 3.125 9.5Z"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M15.875 9.5V5.25C15.875 4.12283 16.3228 3.04183 17.1198 2.2448C17.9168 1.44777 18.9978 1 20.125 1H32.875C34.0022 1 35.0832 1.44777 35.8802 2.2448C36.6772 3.04183 37.125 4.12283 37.125 5.25V9.5"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M1 23.926C8.74942 28.4098 17.5469 30.764 26.5 30.7499C35.4527 30.7642 44.2501 28.4109 52 23.9287"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M30.75 22.25H22.25"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <h4>Business Expertise</h4>
                                    <p>
                                        We guarantee to provide affordable business consulting solutions
                                        that help you reduce costs and improve your profits.
                                    </p>
                                </div>
                                <div
                                    className="why-choose-box-two animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    <div className="why-choose-icon-two">
                                        <svg
                                            width={48}
                                            height={53}
                                            viewBox="0 0 48 53"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M44.9091 5.18182H3.09091C1.93613 5.18182 1 6.11796 1 7.27273V49.0909C1 50.2457 1.93613 51.1818 3.09091 51.1818H44.9091C46.0639 51.1818 47 50.2457 47 49.0909V7.27273C47 6.11796 46.0639 5.18182 44.9091 5.18182Z"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M36.5449 1V9.36364"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M11.4551 1V9.36364"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M24.0005 36.1639L31.7552 40.7273L29.646 32.2095L36.546 26.5117L27.4897 25.8139L24.0005 17.7273L20.5113 25.8139L11.4551 26.5117L18.3551 32.2095L16.2459 40.7273L24.0005 36.1639Z"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <h4>Long Term vision</h4>
                                    <p>
                                        We specialize in serving specific industries, such as healthcare,
                                        finance, or manufacturing, and offer tailored solutions.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="why-choose-right-two">
                                <div
                                    className="why-choose-box-two animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <div className="why-choose-icon-two">
                                        <svg
                                            width={51}
                                            height={51}
                                            viewBox="0 0 51 51"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M25.5 50C39.031 50 50 39.031 50 25.5C50 11.969 39.031 1 25.5 1C11.969 1 1 11.969 1 25.5C1 39.031 11.969 50 25.5 50Z"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M35.7077 25.5C35.7077 41.8333 25.4993 50 25.4993 50C25.4993 50 15.291 41.8333 15.291 25.5C15.291 9.16667 25.4993 1 25.4993 1C25.4993 1 35.7077 9.16667 35.7077 25.5Z"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M2.39258 17.3334H48.6057"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M2.39258 33.6666H48.6057"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <h4>Global Research</h4>
                                    <p>
                                        We stay up to date with the latest technology trends &amp; offer
                                        innovative solutions that help you stay ahead of the competition.
                                    </p>
                                </div>
                                <div
                                    className="why-choose-box-two animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    <div className="why-choose-icon-two">
                                        <svg
                                            width={52}
                                            height={52}
                                            viewBox="0 0 52 52"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M25.75 50.5C39.419 50.5 50.5 39.419 50.5 25.75C50.5 12.081 39.419 1 25.75 1C12.081 1 1 12.081 1 25.75C1 39.419 12.081 50.5 25.75 50.5Z"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M25.75 1L35.2066 27.4773"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M4.31641 13.375L31.9745 18.423"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M4.31641 38.125L22.518 16.6982"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M25.7495 50.5L16.293 24.0226"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M47.1855 38.125L19.5273 33.077"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M47.184 13.375L28.9824 34.8018"
                                                stroke="white"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <h4>Capital Advisory</h4>
                                    <p>
                                        Our solutions are scalable and can grow with your business,
                                        ensuring that you get the most value out of your investment.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default WhyChouse
